import { SortOptionFirstLevel } from '@core-models/sort/sort-option-first-level';
import { ListingInfo } from '@listings/models/listing/listing-info';
import { InitialEmailLayoutType } from '@my-listings/enums/initial-email-layout-type';
import { MyListingsFilterOptions } from '@my-listings/models/filter/my-listings-filter-options';
import { InitialFolderStateModeModel } from '@my-listings/models/initial-folder-state-mode-model';

export const INITIAL_EMAIL_LAYOUT_STATE = new Map<InitialEmailLayoutType, InitialFolderStateModeModel>([
    [InitialEmailLayoutType.NewMatches, {
        filter: MyListingsFilterOptions.getNewMatchFilter(),
        sort: new SortOptionFirstLevel<ListingInfo>('customerAssignedDate')
    }]
]);